import AmiStrings from '../strings.js';

export default function AmiUploadsSidebar() {
    var sbName = 'uploadList';
    var body = <div>
        <div class="eepromForm">
            <input id="uploadSelector" type="file" class="hidden" multiple="multiple" />
            <input id="uploadButton" type="button" value="Select file" />
        </div>
        <table id="uploadHistory" class="eepromHistory" />
    </div>;

    var setTitle;

    return {
        getName: function() { return sbName; },
        isWide: function() { return false; },
        getBody: function() { return body; },
        apply: function(obj) {
            setTitle = obj.setTitle;
        },
        reloadStrings: function() {
            setTitle(AmiStrings.getMenuString('uploads'));
        },
    };
};
